export type Language = "EN" | "KO";

export const languagePathPrefix: Record<Language, string> = {
  EN: "/en",
  KO: "/ko",
};

export const languageHreflang: Record<Language, string> = {
  EN: "en",
  KO: "ko",
};

export const getLanguageFromPath = (pathname: string): Language | null => {
  if (pathname === "/ko" || pathname.startsWith("/ko/")) return "KO";
  if (pathname === "/en" || pathname.startsWith("/en/")) return "EN";
  return null;
};

export const stripLanguagePrefix = (pathname: string): string => {
  const match = pathname.match(/^\/(ko|en)(\/.*)?$/);
  if (!match) return pathname || "/";
  return match[2] || "/";
};

export const localizePath = (pathname: string, language: Language | string): string => {
  const targetLanguage = language === "KO" ? "KO" : "EN";
  const pathWithoutLanguage = stripLanguagePrefix(pathname);
  const normalizedPath =
    pathWithoutLanguage === "/" ? "" : pathWithoutLanguage.startsWith("/") ? pathWithoutLanguage : `/${pathWithoutLanguage}`;

  return `${languagePathPrefix[targetLanguage]}${normalizedPath}`;
};

export const isLocalizedHomePath = (pathname: string): boolean => {
  return stripLanguagePrefix(pathname) === "/";
};

export const isPublicLocalizedPath = (pathname: string): boolean => {
  const pathWithoutLanguage = stripLanguagePrefix(pathname);

  return (
    pathWithoutLanguage === "/" ||
    pathWithoutLanguage === "/about" ||
    pathWithoutLanguage === "/contact" ||
    pathWithoutLanguage === "/gallery" ||
    pathWithoutLanguage === "/insights" ||
    pathWithoutLanguage.startsWith("/insights/")
  );
};

export const getPreferredLanguage = (): Language => {
  const storedLanguage = localStorage.getItem("preferred-language");
  if (storedLanguage === "KO" || storedLanguage === "EN") {
    return storedLanguage;
  }

  return navigator.language.toLowerCase().startsWith("ko") ? "KO" : "EN";
};
